import { useEffect, useState } from "react";
import { useDebounce } from "../../../shared/hooks";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";

export interface InstallmentDetail {
	Installment_id: string;
	Installment_number: number;
	Installment_amount: string;
	Installment_type_amount: string;
	Installment_proposalId: string;
	name: string;
	document: string;
	Installment_due_date: string;
	Installment_obs?: string;
	Installment_payment_method: string;
	installments_count?: number;
	Installment_status: string;
}

export function useInstallments(open: boolean, clientId: string, dataIni: string, dataFim: string, filterByPaymentMethod?: string) {
	const [rows, setRows] = useState<InstallmentDetail[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const { debounce } = useDebounce();

	useEffect(() => {
		if (open && clientId) {
			setIsLoading(true);
			debounce(() => {
				FinancialService.getInstallmentbyDocument(
					1,
					10000,
					clientId,

					dataIni,
					dataFim,
					"Todos", // status
					filterByPaymentMethod // <- agora é passado para o backend
				).then((result) => {
					if (result instanceof Error) {
						console.error("Erro ao buscar detalhes:", result.message);
					} else {
						const formatted = result.data.map((item) => ({
							...item,
							Installment_number: Number(item.Installment_number),
						}));
						setRows(formatted);
					}
					setIsLoading(false);
				});
			});
		}
	}, [open, clientId, dataIni, dataFim, filterByPaymentMethod]);

	return { rows, isLoading };
}
